import React,{ useEffect } from 'react';
import { inject, observer } from "mobx-react";
import _useTranslate from '../../hooks/_useTranslate';
import "./Checkout.css";


const VivaPage = ({ feathersStore })=> {
  
  useEffect(() => {
    const asyncFn = async() => {
       await new Promise((resolve, reject) => {
        const newWindow = window.open(
          `https://${feathersStore.settings?.VIVA_DEMO ? 'demo' : 'www'}.vivapayments.com/web/checkout?ref=${feathersStore?.orderCode}`,"_self");
        if(!newWindow){
          reject (new Error("Popup blocked"));
          return;
        }
        if(newWindow.document.readyState === 'complete'){ //cached
          resolve(newWindow);
          return;
        }
        newWindow.addEventListener('load', () => {
          resolve(newWindow);
        }, {once: true});
      });    
    }
    const _orderItem = localStorage.getItem('fdwa_orderItem');
    const orderItem = JSON.parse(_orderItem);
    const _fdwaState = localStorage.getItem('fdwa_state');
    const fdwaState = JSON.parse(_fdwaState);
    if(feathersStore?.orderCode === fdwaState?.orderCode && orderItem.items?.length > 0){
      asyncFn();
    }    
  }, [feathersStore?.settings, feathersStore?.orderCode, 
      localStorage.getItem('fdwa_orderItem'), localStorage.getItem('fdwa_state')]) 

  return(
    <div className="body-container">
      <div className="grey-header">{"VIVA"}</div>     
    </div>
  )
}

export default inject('feathersStore')(observer(VivaPage));